<template>
  <div>
    <h6 class="text-muted">
      Desglose de tarifa
    </h6>
    <div class="d-flex flex-wrap tariff-tiles">
      <!--internet-->
      <div class="d-flex align-items-center">
        <b-avatar
          square
          size="34"
          variant="light-info"
          class="tariff-tile-icon mr-1"
        >
          <feather-icon
            icon="WifiIcon"
            size="16"
          />
        </b-avatar>
        <div>
          <small
            class="text-muted d-block tariff-tile-label"
          >Internet</small>
          <h5 class="mb-0 tariff-tile-value">
            {{ data.tarifa_in }}
          </h5>
        </div>
      </div>
      <!--tv-->
      <div class="d-flex align-items-center">
        <b-avatar
          square
          size="34"
          variant="light-success"
          class="tariff-tile-icon mr-1"
        >
          <feather-icon
            icon="TvIcon"
            size="16"
          />
        </b-avatar>
        <div>
          <small
            class="text-muted d-block tariff-tile-label"
          >TV</small>
          <h5 class="mb-0 tariff-tile-value">
            {{ data.tarifa_tv }}
          </h5>
        </div>
      </div>
      <!--total-->
      <div class="d-flex align-items-center">
        <b-avatar
          square
          size="34"
          variant="light-danger"
          class="tariff-tile-icon mr-1"
        >
          <feather-icon
            icon="DollarSignIcon"
            size="16"
          />
        </b-avatar>
        <div>
          <small
            class="text-muted d-block tariff-tile-label"
          >Total</small>
          <h5 class="mb-0 tariff-tile-value">
            {{ data.tarifa }}
          </h5>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { BAvatar } from "bootstrap-vue"

export default {
  components: {
    BAvatar,
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
  created() {},
  methods: {},
}
</script>

<style lang="scss" scoped>
.tariff-tiles {
    gap: 1.25rem;
}

.tariff-tile-icon {
    border-radius: var(--tm-radius-sm) !important;
}

.tariff-tile-label {
    font-size: 0.71875rem;
}

.tariff-tile-value {
    font-size: 0.9375rem;
    font-weight: 700;
}
</style>
